import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(16),
  },
  details: {
    fontSize: theme.typography.pxToRem(14),
  },
}));
